'use client';
import React, { useState } from 'react';

import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';

const categories = ['All', 'Rings', 'Necklaces', 'Bracelets', 'Earrings', 'Watches'];

interface GalleryItem {
  label: string;
  category: string;
  brand: string;
  src?: string;
  alt?: string;
}

const galleryItems: GalleryItem[] = [
  {
    src: '/assets/images/image-1788623363499.png',
    alt: 'Model wearing gold starfish bracelet and matching starfish earrings — Uno de 50',
    label: 'Uno de 50 Gold Starfish Bracelet & Earrings',
    category: 'Bracelets',
    brand: 'Uno de 50',
  },
  {
    src: '/assets/images/image-1788623394590.png',
    alt: 'Silver starfish bracelet with pearl beads close-up — Uno de 50',
    label: 'Uno de 50 Silver Starfish & Pearl Bracelet',
    category: 'Bracelets',
    brand: 'Uno de 50',
  },
  {
    src: '/assets/images/image-1788623411438.png',
    alt: 'Silver starfish charm bracelet with crystal beads on wrist — Uno de 50',
    label: 'Uno de 50 Silver Starfish Charm Bracelet',
    category: 'Bracelets',
    brand: 'Uno de 50',
  },
  {
    src: '/assets/images/image-1788623412420.png',
    alt: 'Gold starfish statement earrings close-up — Uno de 50',
    label: 'Uno de 50 Gold Starfish Statement Earrings',
    category: 'Earrings',
    brand: 'Uno de 50',
  },
  {
    src: '/assets/images/image-1788623491221.png',
    alt: 'Model wearing silver starfish necklace with coloured beads and matching earrings — Uno de 50',
    label: 'Uno de 50 Silver Starfish Necklace & Earrings',
    category: 'Necklaces',
    brand: 'Uno de 50',
  },
  {
    src: '/assets/images/image-1788617822713.png',
    alt: 'ChloBo silver charm bracelet close-up with elephant and flower charms',
    label: 'ChloBo Silver Charm Bracelet',
    category: 'Bracelets',
    brand: 'ChloBo',
  },
  {
    src: '/assets/images/image-1788617837916.png',
    alt: 'ChloBo Official Stockist model with stacked silver bracelets',
    label: 'ChloBo Official Stockist — Stacked Silver Bracelets',
    category: 'Bracelets',
    brand: 'ChloBo',
  },
  {
    src: '/assets/images/image-1788617886070.png',
    alt: 'Model with stacked silver and pastel bead bracelets',
    label: 'ChloBo Stacked Silver & Pastel Bead Bracelets',
    category: 'Bracelets',
    brand: 'ChloBo',
  },
  {
    src: '/assets/images/image-1788617923097.png',
    alt: 'Model with stacked silver and orange coral bead bracelets and ChloBo charms',
    label: 'ChloBo Stacked Silver & Coral Bead Bracelets',
    category: 'Bracelets',
    brand: 'ChloBo',
  },
  {
    src: '/assets/images/image-1788617936193.png',
    alt: 'Lifestyle model wearing stacked ChloBo bracelets with rings and necklace outdoors',
    label: 'ChloBo Stacked Bracelets, Rings & Necklace',
    category: 'Bracelets',
    brand: 'ChloBo',
  },
  {
    src: '/assets/images/image-1788615174087.png',
    alt: 'Model wearing gold hoop earrings and white ruffled blouse',
    label: 'Gold Hoop Earrings — On Model',
    category: 'Earrings',
    brand: 'On Model',
  },
  {
    src: '/assets/images/image-1788615187560.png',
    alt: 'Model in black dress wearing pearl and white earrings with pearl clutch bag',
    label: 'Pearl Earrings — On Model',
    category: 'Earrings',
    brand: 'On Model',
  },
  {
    src: '/assets/images/image-1788615201339.png',
    alt: 'Model wearing silver hoop earrings, silver cuff bracelet and ring with white shirt',
    label: 'Silver Hoops & Cuff Bracelet — On Model',
    category: 'Bracelets',
    brand: 'On Model',
  },
  {
    src: '/assets/images/image-1788615214440.png',
    alt: 'Model wearing gold hoop earrings, gold bangles and delicate necklace outdoors',
    label: 'Gold Bangles & Necklace — On Model',
    category: 'Necklaces',
    brand: 'On Model',
  },
  {
    src: '/assets/images/image-1788615226134.png',
    alt: 'ChloBo Official Stockist branded image with stacked silver bracelets',
    label: 'ChloBo Official Stockist — Stacked Silver Bracelets',
    category: 'Bracelets',
    brand: 'ChloBo',
  },
  {
    src: '/assets/images/image-1788623988326.png',
    alt: 'Gold toggle necklace with mandala pendant — Anna Beck',
    label: 'Anna Beck Gold Toggle Necklace with Mandala Pendant',
    category: 'Necklaces',
    brand: 'Anna Beck',
  },
  {
    src: '/assets/images/image-1788623995692.png',
    alt: 'Layered silver and gold necklaces with mandala pendants and stacked bangles and rings — Anna Beck',
    label: 'Anna Beck Layered Necklaces, Bangles & Rings',
    category: 'Necklaces',
    brand: 'Anna Beck',
  },
  {
    src: '/assets/images/image-1788624005984.png',
    alt: 'Layered gold necklaces with mandala pendants on white shirt — Anna Beck',
    label: 'Anna Beck Layered Gold Mandala Necklaces',
    category: 'Necklaces',
    brand: 'Anna Beck',
  },
  {
    src: '/assets/images/image-1788624033857.png',
    alt: 'Stacked silver and gold bangles with chain bracelet and rings — Anna Beck',
    label: 'Anna Beck Stacked Bangles, Chain Bracelet & Rings',
    category: 'Bracelets',
    brand: 'Anna Beck',
  },
  { label: '[Tilly Sveaas minimal drop earrings]', category: 'Earrings', brand: 'Tilly Sveaas' },
  { label: '[Muru moon phase necklace]', category: 'Necklaces', brand: 'Muru' },
  { label: '[SVP sculptural statement ring]', category: 'Rings', brand: 'SVP Rings' },
  { label: '[ChloBo layering necklaces, delicate]', category: 'Necklaces', brand: 'ChloBo' },
  { label: '[Tilly Sveaas geometric ring]', category: 'Rings', brand: 'Tilly Sveaas' },
  { label: '[Muru talisman pendant, close-up]', category: 'Necklaces', brand: 'Muru' },
  { label: '[SVP wide band ring, textured]', category: 'Rings', brand: 'SVP Rings' },
  { label: '[ChloBo stackable rings]', category: 'Rings', brand: 'ChloBo' },
  { label: '[In-store display: new arrivals]', category: 'All', brand: 'In-Store' },
  { label: '[Boutique window display]', category: 'All', brand: 'In-Store' },
  { label: '[Muru charm bracelet, symbolic]', category: 'Bracelets', brand: 'Muru' },
];

export default function GalleryPage() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filtered = activeCategory === 'All'
    ? galleryItems
    : galleryItems.filter((item) => item.category === activeCategory);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Navigation />

      {/* Page Hero */}
      <div className="px-3 md:px-6 py-3 md:py-6 bg-[#FAFAFA]">
        <section
          className="relative flex items-end px-5 md:px-8 pb-10 md:pb-16 overflow-hidden rounded-lg mx-auto"
          style={{ background: '#1A1A1A', minHeight: '44vh', paddingTop: '40px', maxWidth: '1200px' }}
        >
          <div className="absolute inset-0 z-0">
            <img src="/assets/images/image-1788630183595.png" alt="Gold pendant necklaces displayed on sage green textured wall" className="w-full h-full object-cover" />
            <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.2) 100%)' }} />
          </div>
          <div className="relative z-10 max-w-7xl mx-auto w-full">
            <span className="font-sans text-[0.65rem] font-semibold tracking-[0.2em] uppercase text-[#5FA828] block mb-3">New In</span>
            <h1
              className="font-display text-white"
              style={{ fontSize: 'clamp(2.4rem, 7vw, 6rem)', fontWeight: 300, lineHeight: 0.9 }}
            >
              Gallery &amp;
              <br />
              <span style={{ fontStyle: 'italic', color: 'rgba(255,255,255,0.6)' }}>New Arrivals.</span>
            </h1>
          </div>
        </section>
      </div>

      {/* Filter bar */}
      <section className="sticky top-0 z-40 bg-white border-b border-[#E0DDD8]">
        <div className="max-w-7xl mx-auto px-3 md:px-6">
          <div className="flex items-center gap-2 overflow-x-auto py-3 md:py-4">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`font-sans text-[0.62rem] md:text-[0.65rem] tracking-[0.12em] uppercase px-3 md:px-4 py-1.5 md:py-2 rounded-[3px] transition-all duration-200 whitespace-nowrap ${
                  activeCategory === cat
                    ? 'bg-[#5FA828] text-white'
                    : 'bg-transparent text-[#6B6B6B] hover:text-[#2B2B2B] border border-[#E0DDD8]'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery grid */}
      <section className="py-10 md:py-16 px-3 md:px-6 bg-[#FAFAFA]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-4">
            {filtered.map((item, i) => (
              <div
                key={i}
                className="relative group overflow-hidden rounded-[4px] brand-tile"
                style={{ aspectRatio: i % 5 === 0 ? '1/1.3' : '1/1' }}
              >
                {item.src ? (
                  <img
                    src={item.src}
                    alt={item.alt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    style={{ minHeight: '140px' }}
                  />
                ) : (
                  <div
                    className="img-placeholder w-full h-full"
                    style={{ minHeight: '140px', borderRadius: '4px' }}
                  >
                    <span className="text-[0.6rem]">{item.label}</span>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-[4px]">
                  <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                    <p className="font-sans text-[0.6rem] tracking-[0.1em] uppercase text-white/70">{item.brand}</p>
                    <p className="font-sans text-xs text-white">{item.category}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-16 md:py-20">
              <p className="font-sans text-sm text-[#9B9690]">No items in this category yet.</p>
            </div>
          )}
        </div>
      </section>

      {/* Instagram section */}
      <section className="py-10 md:py-16 px-4 md:px-6 bg-[#F5F3EF]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="font-sans text-[0.65rem] font-semibold tracking-[0.2em] uppercase text-[#5FA828] block mb-3">Instagram</span>
            <h2
              className="font-display text-[#2B2B2B]"
              style={{ fontSize: 'clamp(1.8rem, 4vw, 3rem)', fontWeight: 300 }}
            >
              Follow for New Arrivals
            </h2>
            <div className="flex items-center justify-center my-5 md:my-6">
              <div className="w-16 h-px bg-[#E0DDD8]" />
              <div className="w-1 h-1 rounded-full bg-[#E0DDD8] mx-3" />
              <div className="w-16 h-px bg-[#E0DDD8]" />
            </div>
            <a
              href="https://www.instagram.com/amanda13.jewellery/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-sans text-sm text-[#5FA828] hover:underline"
            >
              @amanda13.jewellery
            </a>
          </div>
          <div className="bg-white border border-[#E0DDD8] rounded-[4px] p-5 md:p-8 text-center">
            <p className="font-sans text-sm text-[#9B9690] mb-5 md:mb-6">
              Instagram feed widget — add your Elfsight or SnapWidget embed code here.
            </p>
            <a
              href="https://www.instagram.com/amanda13.jewellery/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              View on Instagram
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
